//#region src/utils/iconNames.ts
var e = (e) => e.includes(".svg"), t = (t) => !t || e(t) ? t : `icon-${t.replace(/^(?:uikit-icon|rioglyph|icon)-/, "")}`;
//#endregion
export { e as isSvgIcon, t as normalizeIconName };

//# sourceMappingURL=iconNames.js.map